import React, { FC, Suspense } from 'react';
import { ADVISORS_ROUTES } from '@trip-ux/constants';
import { Route, Routes } from 'react-router-dom';
import { Progress } from '@trip-ux/components';
import ContactUsPage from '../external/ContactUsPage';
import FaqsPage from '../external/FaqsPage';
import ResourcePage from '../external/ResourceCenter';
import { useSelector } from 'react-redux';
import { ReduxStore } from '@trip-ux/redux-store';
import { lazyWithChunkRetry } from '@trip-ux/common';

const LandingPage = lazyWithChunkRetry(() => import('../external/LandingPage'));

export const ExternalRoutes: FC = () => {
  const { config } = useSelector((store: ReduxStore) => ({
    config: store.config
  }));

  // Helper to convert absolute paths to relative paths for nested routing
  const getRelativePath = (absolutePath: string): string => {
    // Remove the base advisor path to get relative path for nested routing
    const basePath = '/advisor';
    return absolutePath.replace(basePath, '') || '/';
  };

  return (
    <Suspense fallback={<Progress />}>
      <Routes>
        <Route
          path={getRelativePath(ADVISORS_ROUTES[config.locale].WELCOME)}
          element={<LandingPage screen={'landing'} />}
        />
        <Route path={getRelativePath(ADVISORS_ROUTES[config.locale].FAQS)} element={<FaqsPage screen={'faqs'} />} />
        <Route
          path={getRelativePath(ADVISORS_ROUTES[config.locale].CONTACTUS)}
          element={<ContactUsPage screen={'contactUs'} />}
        />
        <Route
          path={getRelativePath(ADVISORS_ROUTES[config.locale].RESOURCE)}
          element={<ResourcePage screen={'resource'} />}
        />
        <Route index element={<LandingPage screen={'landing'} />} />
      </Routes>
    </Suspense>
  );
};

ExternalRoutes.displayName = 'ExternalRoutes';
export default ExternalRoutes;
